<template>
  <a-modal title="添加原料" :visible="hidden" @ok="ok" :bodyStyle="{ padding: '10px' }" :destroyOnClose="true"
    :forceRender="true" @cancel="cancel" :footer="null" width="900px">
    <a-row style="padding: 0 0 10px" type="flex" align="middle" justify="space-between">
      <a-col>
        <a-input-search size="small" v-model="filterData.name" @change="(e) => inputChange(e, 'name')"
          placeholder="原料名称/代码" style="width: 180px; margin-right: 10px" allowClear
          @search="(e) => onSearch(e, 'name')" />
        <a-input-search v-if="overseasFlag == 1" size="small" v-model="filterData.aliasName"
          @change="(e) => inputChange(e, 'aliasName')" placeholder="原料别名" style="width: 180px"
          @search="(e) => onSearch(e, 'aliasName')" />
      </a-col>
      <div>
        <a-checkbox
          v-if="showBagFilter"
          :checked="bagOnly"
          @change="onBagOnlyChange"
          style="margin-right: 10px;"
        >只查看配方组合包原料</a-checkbox>
        <!-- <a-select
          v-model="status"
          placeholder="请选择原料状态"
          @change="getList"
          style="width: 180px; margin-right: 10px"
        >
          <a-select-option :value="0">激活</a-select-option>
          <a-select-option :value="1">失效</a-select-option>
        </a-select> -->
        <base-list-select style="width: 180px" :value="rawType" @change="typeChange" placeholder="选择原料类型"
          category="raw" />
      </div>
    </a-row>
    <a-table :columns="columns" bordered :scroll="{ x: 870, y: 450 }"
      :row-selection="{ selectedRowKeys, onSelect, onSelectAll }" :loading="nutLoading" :data-source="list.records"
      :row-key="(record) => record.id" :pagination="pagination" @change="listChange">

      <template slot="name" slot-scope="text, record">
        {{ overseasFlag == "1" ? record.aliasName || text : text }}
      </template>

      <template slot="fixed3" slot-scope="t">
        {{ t || t === 0 ? Number(t).toFixed(3) : t }}
      </template>

      <template slot="rawTypeName" slot-scope="text, record">
        <a-tooltip @visibleChange="rawTypeNameTipsVisibleChange($event, record)">
          <template slot="title">
            {{ record.fullTypeName }}
          </template>
          <span style="cursor: pointer" :style="{ color: record.color }">{{ text }}</span>
        </a-tooltip>
      </template>

      <div slot="status" slot-scope="text, record">
        <span :style="{ color: !text ? 'green' : 'red' }">{{
          !text ? "激活" : "失效"
          }}</span>/{{ record.categoryTypeName ? record.categoryTypeName : "-" }}
      </div>

      <template slot="turnoverDayTitle">
        <label>可耗用天数</label>
        <a-tooltip style="position: relative;top: 1px;margin-left: 4px">
          <template slot="title">期末库存量/近30日平均耗用量</template>
          <a-icon type="exclamation-circle" />
        </a-tooltip>
      </template>

      <template slot="turnoverDay" slot-scope="text, record">
        <a-tooltip v-if="turnoverDayTip(record)" style="margin-right: 4px;">
          <template slot="title">
            高库存原料：{{ record.purchaseClass + ' > ' + (record.purchaseClassCode === '1001' ? '15' : '30') }}天
          </template>
          <a-icon type="info-circle" style="color: orange;" />
        </a-tooltip>
        <label :style="{ color: turnoverDayTip(record) ? 'orange' : '' }">{{ text }}</label>
      </template>
    </a-table>

    <a-row type="flex" justify="space-between" class="footer">
      <span>
        <span style="font-size: 12px" v-if="selectedRows.length">
          已选中 {{ selectedRows.length }}条原料
        </span>
      </span>
      <a-space>
        <a-button @click="cancel">取消</a-button>
        <a-button @click="ok" type="primary">保存</a-button>
      </a-space>
    </a-row>
  </a-modal>
</template>

<script>
import { nhfMixins } from '../../untils';
import BaseListSelect from '../select/BaseListSelect.vue';
export default {
  components: { BaseListSelect },
  props: ['hidden'],
  mixins: [nhfMixins],
  computed: {
    showBagFilter() {
      const isStartBag = this.detail && (this.detail.isStartBag === '1' || this.detail.isStartBag === 1 || this.detail.isStartBag === true)
      return !!isStartBag
    }
  },
  data() {
    return {
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      nutLoading: false,
      filterData: {},
      list: {},
      showFooter: false,
      status: undefined,
      rawType: [],
      bagOnly: false,
      columns: [
        {
          dataIndex: 'name',
          title: '原料名称',
          // width: 300,
          scopedSlots: { customRender: 'name' },
        },
        {
          dataIndex: 'code',
          align: 'center',
          title: '代码',
          width: 110,
        },
        {
          dataIndex: 'rawTypeName',
          title: '类型',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'rawTypeName' },
        },
        {
          dataIndex: 'storageWeight',
          title: '库存量',
          scopedSlots: { customRender: 'fixed3' },
          align: 'center',
          width: 120,
        },
        {
          dataIndex: 'unit',
          title: '单位',
          align: 'center',
          width: 80,
        },
        {
          // title: "可耗用天数",
          dataIndex: "turnoverDay",
          width: 120,
          ellipsis: true,
          align: 'center',
          scopedSlots: { title: 'turnoverDayTitle', customRender: "turnoverDay" },
        },
        {
          title: '状态/类目归属',
          dataIndex: 'status',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'status' }
        },
      ]
    };
  },
  mounted() {
    // this.getList(this.pagination)
  },
  watch: {
    hidden(val) {
      this.pagination.current = 1;
      this.pagination.pageSize = 100;
      let { current = 1, pageSize = 100 } = this.pagination || {};
      if (val) {
        // 打开弹窗时重置组合包筛选
        this.bagOnly = false;
        // 清除上次的组合包过滤字段
        delete this.filterData.isFilterBag;
        this.getList({ current, size: pageSize });
      } else {
        this.restList();
      }
    }
  },
  methods: {
    inputChange({ target }, feild) {
      this.pagination.current = 1;
      let { current = 1, pageSize = 100 } = this.pagination || {};
      this.getList({ [feild]: target.value, current, size: pageSize });
    },

    ok() {
      if (this.selectedRows.length) {
        this.$emit('ok', this.selectedRows);
        this.cleanSelect();
      } else {
        this.$message.warn('选择需要添加的原料');
      }
    },

    cancel() {
      this.$emit('cancel');
    },

    getList(arg = {}) {
      return this.fetchGet({
        actions: this.myRawpage,
        isList: true,
        name: 'list',
        loading: 'nutLoading',
        data: {
          ...this.filterData,
          factoryId: this.factoryId,
          formulaId: this.formulaId,
          ...arg,
          // size:2000,
          // status: this.status,
        }
      });
    },

    onSearch(name, feild) {
      this.pagination.current = 1;
      let { current = 1, pageSize = 100 } = this.pagination || {};
      this.getList({ [feild]: name, current, size: pageSize });
    },

    typeChange(val) {
      this.rawType = val;
      const typeId = [...val].pop();
      this.filterData.typeId = typeId;
      this.pagination.current = 1;
      let { current = 1, pageSize = 100 } = this.pagination || {};
      this.getList({ typeId, current, size: pageSize });
    },
    restList() {
      this.rawType = [];
      this.filterData = {};
      this.cleanSelect();
    },
    onBagOnlyChange(e) {
      const checked = e && e.target ? e.target.checked : !!e;
      this.bagOnly = checked;
      // 后端过滤：isFilterBag === 1 时过滤
      if (checked) {
        this.filterData = {
          ...this.filterData,
          isFilterBag: 1,
        };
      } else {
        // 取消时去除相关过滤字段
        const rest = { ...(this.filterData || {}) };
        delete rest.isFilterBag;
        this.filterData = { ...rest };
      }
      this.pagination.current = 1;
      let { current = 1, pageSize = 100 } = this.pagination || {};
      this.getList({ current, size: pageSize });
    },
    listChange(page) {
      this.getList({ ...this.tablePageChange(page), ...this.filterData });
    },
    rawTypeNameTipsVisibleChange(show, item) {
      item.color = show ? '#1677FF' : '';
      this.$forceUpdate();
    },

    turnoverDayTip(record) {
      //purchaseClassCode 1001: 大料，其余为小料
      if ((record.purchaseClassCode === '1001' && record.turnoverDay > 15)
        || (record.purchaseClassCode !== '1001' && record.turnoverDay > 30)) {
        return true;
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.footer {
  padding: 10px 15px 0;
  margin: 10px -10px 0;
  border-top: 1px solid #eee;
}
</style>
